import { type AddToCartEventItem } from './eCommerceTrackingEventSchema';
import { StateCartEntry } from '../store/carts/CartsState';
import { buildBaseTrackingItem } from './buildBaseTrackingItem';
import { getListContext } from './listContextStorage';

export const convertCartEntryToAddToCartEventItem = (
  entry: StateCartEntry,
  index: number,
  country: string,
  preOrderEnabled: boolean,
  pricesIncludeTax: boolean
): AddToCartEventItem => {
  const { product, quantity, tracking, totalPrice } = entry;
  const perUnitPrice: number =
    quantity > 0 ? Math.round((totalPrice.valueWithoutTax / quantity) * 100) / 100 : 0;
  const listContext =
    tracking?.itemListId || tracking?.itemListName
      ? { originId: tracking.itemListId ?? '', originType: tracking.itemListName ?? '' }
      : getListContext(product.code);
  const categoryNames: ReadonlyArray<string> = product.categoryWithParents.map(({ name }) => name);

  const item = buildBaseTrackingItem({
    id: product.code,
    name: product.name,
    brandName: product.brand?.name ?? null,
    categoryNames,
    listContext,
    badges: product.badges ?? null,
    stockLevelIndication: product.stockLevelIndication,
    preOrderSettings: product.preOrderSettings,
    preOrderEnabled,
    pricesIncludeTax,
    country,
    price: perUnitPrice,
    prices: {
      currentPrice: product.currentPrice,
      campaignPrice: product.campaignPrice,
      strikePrice: product.strikePrice,
      recommendedRetailPrice: product.recommendedRetailPrice
    }
  });

  return {
    ...item,
    quantity,
    index
  };
};
